/* QUINTO · Menú: apertura al pasar el ratón, paneles en el menú móvil y filtro ?f= en la tienda */
(function(){
  var NOMBRES={'TIENDA':'Tienda','Tienda-Quinto Lab':'Quinto Lab'};
  var FILTROS={'perfil:dulce-reconfortante':'Dulce y reconfortante','perfil:dulce-especial':'Dulce con algo especial','perfil:frutal-vibrante':'Frutal y vibrante','perfil:especiado-caracter':'Especiado y con carácter','tipo:descafeinado':'Sin cafeína','ideal:espresso':'Para espresso','ideal:moka':'Para moka','ideal:filtro':'Para filtro (V60, Chemex)','ideal:prensa':'Para prensa francesa','ideal:aeropress':'Para AeroPress','ideal:coldbrew':'Para cold brew','ideal:leche':'Para café con leche'};

  function hover(){
    if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    var items=[].slice.call(document.querySelectorAll('.header__inline-menu details.mega-menu'));
    items.forEach(function(d){
      var li=d.closest('li'), t=null;
      li.addEventListener('mouseenter',function(){ clearTimeout(t); items.forEach(function(o){ if(o!==d && o.open){ o.open=false; o.querySelector('summary').setAttribute('aria-expanded','false'); } }); if(!d.open){ d.open=true; d.querySelector('summary').setAttribute('aria-expanded','true'); } });
      li.addEventListener('mouseleave',function(){ t=setTimeout(function(){ d.open=false; d.querySelector('summary').setAttribute('aria-expanded','false'); },180); });
    });
  }

  function drawer(){
    ['tienda','suscripcion','blog'].forEach(function(h){
      var tpl=document.getElementById('qm-movil-'+h), sub=document.getElementById('link-'+h);
      if(!tpl||!sub) return;
      var inner=sub.querySelector('.menu-drawer__inner-submenu'); if(!inner) return;
      var ul=inner.querySelector(':scope > ul.menu-drawer__menu'); if(ul) ul.remove();
      var wrap=document.createElement('div'); wrap.className='qm-drawer'; wrap.appendChild(tpl.content.cloneNode(true));
      inner.appendChild(wrap);
    });
    document.querySelectorAll('.menu-drawer__menu-item, .menu-drawer__close-button').forEach(function(el){
      el.childNodes.forEach(function(n){ if(n.nodeType===3){ var k=n.textContent.trim(); if(NOMBRES[k]) n.textContent=n.textContent.replace(k,NOMBRES[k]); } });
    });
  }

  function filtro(){
    var f=new URLSearchParams(location.search).get('f'); if(!f) return;
    f=f.toLowerCase();
    var grid=document.querySelector('[data-qo-grid]'); if(!grid) return;
    var n=0;
    grid.querySelectorAll('.card').forEach(function(c){ var ok=(c.dataset.t||'').indexOf('|'+f+'|')>-1; c.style.display=ok?'':'none'; if(ok) n++; });
    if(n===0){ grid.querySelectorAll('.card').forEach(function(c){c.style.display=''}); return; }
    var filt=grid.closest('.wrap') && grid.closest('.wrap').querySelector('[data-qo-filt]');
    if(filt){ filt.querySelectorAll('button').forEach(function(b){ b.classList.toggle('on', b.dataset.f===f); }); }
    var nombre=FILTROS[f]; if(!nombre && f.indexOf('pais:')===0){ nombre='Café de '+f.slice(5).replace(/-/g,' ').replace(/^./,function(m){return m.toUpperCase()}); }
    var aviso=document.createElement('div'); aviso.className='qm-aviso';
    aviso.innerHTML='<span>'+(nombre||'Filtrado')+' · '+n+(n===1?' café':' cafés')+'</span><a href="'+location.pathname+'#cafes">Ver todos</a>';
    grid.parentNode.insertBefore(aviso, grid);
    aviso.querySelector('a').addEventListener('click',function(e){ e.preventDefault(); history.replaceState(null,'',location.pathname+'#cafes'); grid.querySelectorAll('.card').forEach(function(c){c.style.display=''}); if(filt){ filt.querySelectorAll('button').forEach(function(b){ b.classList.toggle('on', b.dataset.f==='all'); }); } aviso.remove(); });
  }

  function init(){ hover(); drawer(); filtro(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
